import styled, { css } from 'styled-components';
import { theme, palette } from 'styled-tools';

interface BannerStyleProps {
  show?: boolean;
  error?: boolean;
}

export const Banner = styled.div<BannerStyleProps>`
  width: 100%;
  position: absolute;
  top: 60px;
  left: 0;
  z-index: 2;
  align-items: center;

  ${(props) =>
    props.error
      ? css`
          background-color: ${palette('gray_opacity_50')};
        `
      : null}

  ${(props) =>
    props.show
      ? css`
          display: flex;
        `
      : css`
          display: none;
        `}
`;
export const BackgroundLayer = styled.div<BannerStyleProps>`
  width: 100%;
  ${(props) =>
    props.error
      ? css`
          background-color: ${palette('red_opacity_100')};
        `
      : null};
`;
export const ContentWrpper = styled.div`
  width: 100%;
  max-width: 940px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const MessageWrpper = styled.div`
  ${theme('fontStyle.body2')}
  display: flex;
  align-items: center;
  @media only screen and (min-width: 550px) {
    height: 60px;
  }
`;

export const ErrorIconWrapper = styled.div`
  display: flex;
  align-self: center;
  margin-right: 8px;
  > svg {
    width: 24px;
    height: 24px;
  }
`;

export const CloseWrapper = styled.div`
  > button {
    width: 24px;
    height: 24px;
  }
`;
